export default {
  MODE_POST: "post",
  MODE_SEARCH: "search",

  VIEW_TYPE_LIST: "list",
  VIEW_TYPE_MAP: "map",
};
